const articlesData = [
    {
        title: 'Grilled Tomatoes at Home',
        image: require('../assets/article1.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
    {
        title: 'Snacks for Travel',
        image: require('../assets/article2.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
    {
        title: 'Post-workout Recipes',
        image: require('../assets/article3.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
    {
        title: 'How To Grill Corn',
        image: require('../assets/article4.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
    {
        title: 'Crunchwrap Supreme',
        image: require('../assets/article5.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
    {
        title: 'Broccoli Cheese Soup',
        image: require('../assets/article6.png'),
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard...',
    },
];

export default articlesData;